import React, { useState } from "react";
import { Table, Row, Col, Form, Button, Pagination } from "react-bootstrap";
import {
  BarChart3,
  ArrowUpDown,
  ArrowUp,
  ArrowDown,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import { CiSearch } from "react-icons/ci";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { LuDownload } from "react-icons/lu";
import Chart from "../Charts/Chart";
import { FiChevronRight, FiChevronDown } from "react-icons/fi";
import { Layers, GitBranch } from "lucide-react";
import { useTheme } from "../../Themecontext/Themecontext";

const PayRollParentChild = ({
  columns = [],
  data = [],
  parentKey,
  childKey,
  externalTotals = {},
  parentTotals = {},
  childTotals = {},
}) => {
  const { Colourdata } = useSelector((state) => state.ClientLogin);

  console.log(parentTotals);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWPAYROLL");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWPAYROLLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const [search, setSearch] = useState("");
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const [selectedRow, setSelectedRow] = useState(null);

  const [expandedParent, setExpandedParent] = useState(new Set());
  const [expandedChild, setExpandedChild] = useState(new Set());

  const isSingleLevel = !childKey || childKey === parentKey;

  const toggleAllParents = () => {
    const allParents = Object.keys(groupedData);

    if (expandedParent.size === allParents.length) {
      // sab open hai → close kar do
      setExpandedParent(new Set());
    } else {
      // open kar do
      setExpandedParent(new Set(allParents));
    }
  };

  const toggleAllChildren = () => {
    const allChildren = [];

    if (!isSingleLevel) {
      Object.keys(groupedData).forEach((parent) => {
        Object.keys(groupedData[parent]).forEach((child) => {
          allChildren.push(parent + "-" + child);
        });
      });
    }

    if (expandedChild.size === allChildren.length) {
      setExpandedChild(new Set());
    } else {
      setExpandedChild(new Set(allChildren));
    }
  };

  /* SEARCH */

  const filteredData = data.filter((row) =>
    Object.values(row).some((val) =>
      val?.toString().toLowerCase().includes(search.trim().toLowerCase()),
    ),
  );

  /* NUMBER FORMAT */

  const formatIndianNumber = (num) => {
    const number = Number(num);
    if (isNaN(number)) return num;

    return number.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  /* SORTING */

  const handleSort = (key) => {
    let direction = "desc";

    if (sortConfig.key === key) {
      if (sortConfig.direction === "desc") {
        direction = "asc";
      } else if (sortConfig.direction === "asc") {
        setSortConfig({
          key: null,
          direction: null,
        });
        return;
      }
    }

    setSortConfig({ key, direction });
  };

  const sortedData = [...filteredData].sort((a, b) => {
    if (!sortConfig.key || !sortConfig.direction) return 0;

    let aValue = a[sortConfig.key];
    let bValue = b[sortConfig.key];

    const cleanA = String(aValue).replace(/,/g, "");
    const cleanB = String(bValue).replace(/,/g, "");

    if (!isNaN(cleanA) && !isNaN(cleanB)) {
      aValue = Number(cleanA);
      bValue = Number(cleanB);
    }

    if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;

    if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;

    return 0;
  });

  // ---------parent child---------

  const groupData = () => {
    const grouped = {};

    // SINGLE LEVEL
    if (isSingleLevel) {
      sortedData.forEach((row) => {
        const parent = row[parentKey];

        if (!grouped[parent]) grouped[parent] = [];

        grouped[parent].push(row);
      });

      return grouped;
    }

    // PARENT + CHILD LEVEL
    sortedData.forEach((row) => {
      const parent = row[parentKey];
      const child = row[childKey];

      if (!grouped[parent]) grouped[parent] = {};

      if (!grouped[parent][child]) grouped[parent][child] = [];

      grouped[parent][child].push(row);
    });

    return grouped;
  };
  const groupedData = groupData();

  const groupOrder = {
    Liabilities: 1,
    Assets: 2,
    Income: 3,
    Expense: 4,
  };

  const sortedParents = Object.keys(groupedData).sort((a, b) => {
    return (groupOrder[a] || 999) - (groupOrder[b] || 999);
  });
  const toggleParent = (parent) => {
    const newSet = new Set(expandedParent);
    newSet.has(parent) ? newSet.delete(parent) : newSet.add(parent);
    setExpandedParent(newSet);
  };

  const toggleChild = (childKey) => {
    const newSet = new Set(expandedChild);
    newSet.has(childKey) ? newSet.delete(childKey) : newSet.add(childKey);
    setExpandedChild(newSet);
  };

  const calculateTotals = (rows) => {
    const totals = {};

    rows.forEach((row) => {
      Object.keys(row).forEach((key) => {
        const value = Number(String(row[key]).replace(/,/g, ""));

        if (!isNaN(value)) {
          totals[key] = (totals[key] || 0) + value;
        }
      });
    });

    return totals;
  };

  const getExternalTotal = (source, groupName, key) => {
    if (source && source[groupName] && source[groupName][key] !== undefined) {
      return source[groupName][key];
    }

    return undefined;
  };

  /* PAGINATION */

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;

  const currentRows = sortedData.slice(indexOfFirstRow, indexOfLastRow);

  const totalPages = Math.ceil(sortedData.length / rowsPerPage);

  /* VISIBLE PAGE CONTROL */

  const visiblePages = 4;

  let startPage = Math.max(1, currentPage - Math.floor(visiblePages / 2));
  let endPage = startPage + visiblePages - 1;

  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - visiblePages + 1);
  }

  const grandTotals = calculateTotals(sortedData);

  const downloadCSV = () => {
    if (!sortedData || sortedData.length === 0) return;

    // headers
    const headers = columns.map((col) => col.label);

    // rows
    const rows = sortedData.map((row) =>
      columns.map((col) => {
        let value = row[col.key];

        // commas handle karne ke liye quotes
        if (typeof value === "string" && value.includes(",")) {
          value = `"${value}"`;
        }

        return value ?? "";
      }),
    );

    // combine
    const csvContent = [headers, ...rows].map((e) => e.join(",")).join("\n");

    // file create
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    // download trigger
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "table_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const dashColumns = [
    "srNumber",
    "AcName",
    "Groupseq",
    "acname",
    "GroupMstName",
    "AcLaieName",
    "GroupMStName",
  ];

  const isDashColumn = (key) => dashColumns.includes(key);

  const showChildButton = !isSingleLevel;

  return (
    <>
      <style>
        {`
  .custom-pagination {
    gap: 8px;
  }

  /* DEFAULT */
  .custom-pagination .page-item .page-link {
    border: none !important;
    border-radius: 8px !important;
    min-width: 34px;
    height: 34px;
    display: flex !important;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    background: ${isdark === "light" ? iscolour?.Colour9 : iscolourDark?.Colour6};
        color: ${isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour3};
  }

  /* ACTIVE */
  .custom-pagination .page-item.active .page-link {
    background: ${isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour9};
    color: ${isdark === "light" ? "#fff" : iscolourDark?.Colour3} !important;
  }

  /* HOVER */
  .custom-pagination .page-item .page-link:hover {
  background: ${isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour11};
  }
  .search-input::placeholder {
                                    color: ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour9};
                                    opacity: 1;
                                    }
                                    .search-input:focus {
  border-color: ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7} !important;
  box-shadow: 0 0 0 0.2rem ${isdark === "light" ? `${iscolour?.Colour6}40` : `${iscolourDark?.Colour7}40`} !important;
  outline: none !important;
}
  `}
      </style>
      <div
        style={{
          width: "100%",
          background:
            isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour8,
        }}
      >
        {/* TOP BAR */}

        <Row className="g-2 align-items-center mb-2 m-0 px-2 px-md-3">
          {/* Search */}
          <Col xs={12} md={5} lg={5} xl={4}>
            <div
              style={{
                position: "relative",
                width: "100%",
              }}
            >
              <CiSearch
                size={20}
                style={{
                  position: "absolute",
                  left: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color:
                    isdark === "light"
                      ? iscolour?.Colour8
                      : iscolourDark?.Colour12,
                  zIndex: 1,
                }}
              />

              <Form.Control
                className="search-input"
                type="text"
                placeholder="Search..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                }}
                style={{
                  borderRadius: "8px",
                  height: "40px",
                  padding: "0 10px 0 35px",
                  border: `1px solid ${isdark === "light"
                    ? iscolour?.Colour4
                    : iscolourDark?.Colour3
                    }`,
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour2
                      : iscolourDark?.Colour4,
                  color: isdark === "light" ? "#000" : "#fff",
                }}
              />
            </div>
          </Col>

          {/* Buttons */}
          <Col
            xs={12}
            md={7}
            lg={7}
            xl={8}
            style={{ textAlign: "right" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "8px",
                flexWrap: "wrap",
              }}
            >
              {/* Parent Button */}
              <Button
                className="hover-scale-btn"
                onClick={toggleAllParents}
                style={{
                  background:
                    isdark === "light"
                      ? iscolour?.Colour4
                      : iscolourDark?.Colour9,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour9
                      : iscolourDark?.Colour4,
                  border: "none",
                  borderRadius: "8px",
                  height: "40px",
                  fontSize: "13px",
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                {expandedParent.size === Object.keys(groupedData).length
                  ? "Close Parent"
                  : "Open Parent"}
              </Button>

              {/* Child Button */}
              {showChildButton && (
                <Button
                  className="hover-scale-btn"
                  onClick={toggleAllChildren}
                  style={{
                    background:
                      isdark === "light"
                        ? iscolour?.Colour9
                        : iscolourDark?.Colour11,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    border: "none",
                    borderRadius: "8px",
                    height: "40px",
                    fontSize: "13px",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  {expandedChild.size > 0
                    ? "Close Child"
                    : "Open Child"}
                </Button>
              )}

              {/* Download Button */}
              <Button
                onClick={downloadCSV}
                className="hover-scale-btn"
                style={{
                  background:
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour10,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour1,
                  border: "none",
                  borderRadius: "8px",
                  height: "40px",
                  padding: "0 16px",
                  fontSize: "14px",
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <LuDownload size={16} />
                <span>Download CSV</span>
              </Button>
            </div>
          </Col>
        </Row>

        {/* TABLE */}

        <div
          className="grey-scroll"
          style={{
            overflowX: sortedData.length > 0 ? "auto" : "hidden",
            overflowY: "auto",
            width: "100%",
            height: "400px",
            scrollbarWidth: "thin",
            position: "relative",
            scrollbarColor:
              isdark === "light"
                ? `${iscolour?.Colour7} ${iscolour?.Colour3}`
                : `${iscolourDark?.Colour7} ${iscolourDark?.Colour3}`,
          }}
        >
          {currentRows.length > 0 ? (
            <table
              style={{
                borderCollapse: "collapse",
                width: "100%",
                minWidth: "900px",
              }}
            >
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 999,
                }}
              >
                <tr>
                  <th
                    style={{
                      width: "40px",
                      osition: "sticky",
                      top: 0,
                      zIndex: 1000,
                      background:
                        isdark === "light"
                          ? iscolour?.Colour3
                          : iscolourDark?.Colour8,
                    }}
                  ></th>

                  {columns.map((col, index) => (
                    <th
                      key={index}
                      onClick={() => handleSort(col.key)}
                      style={{
                        padding: "15px",
                        fontWeight: "700",
                        fontSize: "13px",
                        textAlign: "center",
                        cursor: "pointer",
                        verticalAlign: "middle",
                        whiteSpace: "nowrap",
                        position: "sticky",
                        top: 0,
                        background:
                          isdark === "light"
                            ? iscolour?.Colour3
                            : iscolourDark?.Colour8,
                        color:
                          isdark === "light" ? "#000" : iscolourDark?.Colour1,
                        zIndex: 1,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "6px",
                        }}
                      >
                        {col.label}

                        {sortConfig.key === col.key ? (
                          sortConfig.direction === "asc" ? (
                            <ArrowUp size={14} />
                          ) : (
                            <ArrowDown size={14} />
                          )
                        ) : (
                          <ArrowUpDown size={14} />
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {sortedParents.map((parent, pIndex) => {
                  const isParentOpen = expandedParent.has(parent);
                  const parentRows = isSingleLevel
                    ? groupedData[parent]
                    : Object.values(groupedData[parent]).flat();
                  const hasMultipleParentRows = parentRows.length > 1;

                  return (
                    <React.Fragment key={pIndex}>
                      {/* 🔷 PARENT ROW */}
                      <tr
                        onClick={() => {
                          if (hasMultipleParentRows) {
                            toggleParent(parent);
                          }
                        }}
                        style={{
                          backgroundColor:
                            pIndex % 2 === 0
                              ? isdark === "light"
                                ? iscolour?.Colour5
                                : iscolourDark?.Colour4
                              : isdark === "light"
                                ? iscolour?.Colour5
                                : iscolourDark?.Colour4,
                          color:
                            pIndex % 2 === 0
                              ? isdark === "light"
                                ? iscolour?.Colour12
                                : iscolourDark?.Colour12
                              : isdark === "light"
                                ? iscolour?.Colour12
                                : iscolourDark?.Colour12,
                          cursor: "pointer",
                          fontWeight: "600",
                        }}
                      >
                        {/* arrow */}
                        <td
                          style={{ textAlign: "center", padding: "0px 10px" }}
                        >
                          <div
                            style={{
                              width: "30px",
                              height: "30px",
                              borderRadius: "50%",
                              background: hasMultipleParentRows
                                ? isdark === "light"
                                  ? iscolour?.Colour6
                                  : iscolourDark?.Colour10
                                : "transparent",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour1
                                  : iscolourDark?.Colour1,
                              margin: "auto",
                            }}
                          >
                            {hasMultipleParentRows ? (
                              isParentOpen ? (
                                <FiChevronDown />
                              ) : (
                                <FiChevronRight />
                              )
                            ) : null}
                          </div>
                        </td>

                        {columns.map((col, i) => {
                          const parentRows = isSingleLevel
                            ? groupedData[parent]
                            : Object.values(groupedData[parent]).flat();

                          const totals = calculateTotals(parentRows);

                          let value = "";
                          const dashColumns = [""];

                          if (col.key === parentKey) {
                            value = parent;
                          } else if (dashColumns.includes(col.key)) {
                            value = "(Multipal)"; // 👈 yaha "-" show hoga
                          } else if (col.key === "count") {
                            value = parentRows.length;
                          } else if (col.key === "srNumber") {
                            value = pIndex + 1;
                          } else {
                            // 👇 single record ho to direct value show karo
                            if (parentRows.length === 1) {
                              value = parentRows[0][col.key] ?? "";
                            } else {
                              // 👇 multiple ho to total / multiple show karo
                              const externalValue = getExternalTotal(
                                parentTotals,
                                parent,
                                col.key,
                              );

                              const finalValue =
                                externalValue !== undefined
                                  ? externalValue
                                  : totals[col.key];

                              if (finalValue !== undefined) {
                                value = formatIndianNumber(finalValue);
                              } else {
                                value = "(Multiple)";
                              }
                            }
                          }

                          return (
                            <td
                              key={i}
                              style={{
                                padding: "15px",
                                textAlign: col.align || "left",
                              }}
                            >
                              {col.format &&
                                value !== "" &&
                                value !== "(Multiple)"
                                ? formatIndianNumber(value)
                                : value}
                            </td>
                          );
                        })}
                      </tr>

                      {/* 🔷 SINGLE LEVEL DATA */}
                      {isSingleLevel &&
                        hasMultipleParentRows &&
                        isParentOpen &&
                        groupedData[parent].map((row, rowIndex) => (
                          <tr
                            key={rowIndex}
                            style={{
                              backgroundColor:
                                rowIndex % 2 === 0
                                  ? isdark === "light"
                                    ? iscolour?.Colour1
                                    : iscolourDark?.Colour1
                                  : isdark === "light"
                                    ? iscolour?.Colour3
                                    : iscolourDark?.Colour2,
                            }}
                          >
                            <td style={{ width: "40px" }}></td>

                            {columns.map((col, colIndex) => {
                              let value = row[col.key];

                              if (col.key === "srNumber") {
                                value = rowIndex + 1;
                              } else if (col.key === "count") {
                                value = "";
                              } else if (
                                rowIndex > 0 &&
                                col.key === parentKey
                              ) {
                                value = "";
                              }

                              return (
                                <td
                                  key={colIndex}
                                  style={{
                                    padding: "15px",
                                    textAlign: col.align || "left",
                                    fontSize: "14px",
                                    fontWeight: "600",
                                    whiteSpace: "nowrap",
                                    color:
                                      col.colors ||
                                      (isdark === "light"
                                        ? iscolour?.Colour12
                                        : iscolourDark?.Colour12),
                                  }}
                                >
                                  {col.key === "charts" ? (
                                    <div
                                      onClick={() => setSelectedRow(row)}
                                      style={{
                                        background: "#cde3d5",
                                        width: "32px",
                                        height: "32px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: "8px",
                                        color: "#C9A13B",
                                        margin: "auto",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <BarChart3 size={16} />
                                    </div>
                                  ) : col.format ? (
                                    formatIndianNumber(value)
                                  ) : (
                                    value
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        ))}

                      {/* 🔷 CHILD LEVEL */}
                      {!isSingleLevel &&
                        isParentOpen &&
                        Object.keys(groupedData[parent]).map(
                          (child, cIndex) => {
                            const childKeyUnique = parent + "-" + child;
                            // 👇 sabse pehle declare karo
                            const childRows = groupedData[parent][child];

                            const isChildOpen =
                              expandedChild.has(childKeyUnique);
                            const hasMultipleChildRows = childRows.length > 1;

                            return (
                              <React.Fragment key={cIndex}>
                                {/* CHILD ROW */}
                                <tr
                                  onClick={() => {
                                    if (hasMultipleChildRows) {
                                      toggleChild(childKeyUnique);
                                    }
                                  }}
                                  style={{
                                    backgroundColor:
                                      isdark === "light"
                                        ? iscolour?.Colour3
                                        : iscolourDark?.Colour2,
                                    color:
                                      isdark === "light"
                                        ? iscolour?.Colour12
                                        : iscolourDark?.Colour12,
                                    cursor: "pointer",
                                  }}
                                >
                                  {/* arrow */}
                                  <td style={{ textAlign: "center" }}>
                                    <div
                                      style={{
                                        width: "25px",
                                        height: "25px",
                                        borderRadius: "50%",
                                        background: hasMultipleChildRows
                                          ? isdark === "light"
                                            ? iscolour?.Colour5
                                            : iscolourDark?.Colour10
                                          : "transparent",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color:
                                          isdark === "light"
                                            ? iscolour?.Colour1
                                            : iscolourDark?.Colour1,
                                        margin: "auto",
                                        cursor: "pointer",
                                        transition: "0.2s",
                                      }}
                                    >
                                      {hasMultipleChildRows ? (
                                        isChildOpen ? (
                                          <FiChevronDown />
                                        ) : (
                                          <FiChevronRight />
                                        )
                                      ) : null}
                                    </div>
                                  </td>

                                  {columns.map((col, i) => {
                                    const totals = calculateTotals(childRows);

                                    let value = "";
                                    const dashColumns = [""];

                                    if (col.key === childKey) {
                                      value = child;
                                    } else if (dashColumns.includes(col.key)) {
                                      value = "(Multipal)"; // 👈 yaha "-" show hoga
                                    } else if (col.key === "count") {
                                      value = childRows.length;
                                    } else if (col.key === "srNumber") {
                                      value = cIndex + 1;
                                    } else {
                                      // 👇 single child record ho to direct data show
                                      if (childRows.length === 1) {
                                        value = childRows[0][col.key] ?? "";
                                      } else {
                                        // 👇 multiple ho to total/multiple
                                        if (totals[col.key] !== undefined) {
                                          value = formatIndianNumber(
                                            totals[col.key],
                                          );
                                        } else {
                                          value = "(Multiple)";
                                        }
                                      }
                                    }
                                    return (
                                      <td
                                        key={i}
                                        style={{
                                          padding: "15px",
                                          textAlign: col.align || "left",
                                        }}
                                      >
                                        {col.format &&
                                          value !== "" &&
                                          value !== "(Multiple)"
                                          ? formatIndianNumber(value)
                                          : value}
                                      </td>
                                    );
                                  })}
                                </tr>

                                {hasMultipleChildRows &&
                                  isChildOpen &&
                                  groupedData[parent][child].map(
                                    (row, rowIndex) => (
                                      <tr
                                        key={rowIndex}
                                        style={{
                                          backgroundColor:
                                            rowIndex % 2 === 0
                                              ? isdark === "light"
                                                ? iscolour?.Colour1
                                                : iscolourDark?.Colour1
                                              : isdark === "light"
                                                ? iscolour?.Colour2
                                                : iscolourDark?.Colour2,
                                        }}
                                      >
                                        <td style={{ width: "40px" }}></td>
                                        {columns.map((col, colIndex) => {
                                          let value = row[col.key];

                                          if (col.key === "srNumber") {
                                            value = rowIndex + 1;
                                          } else if (col.key === "count") {
                                            value = "";
                                          } else if (rowIndex === 0) {
                                            if (col.key === parentKey)
                                              value = parent;
                                            else if (col.key === childKey)
                                              value = child;
                                            else value = value || "";
                                          } else {
                                            if (
                                              col.key === parentKey ||
                                              col.key === childKey
                                            ) {
                                              value = "";
                                            } else if (value === "(Multiple)") {
                                              value = "";
                                            }
                                          }

                                          return (
                                            <td
                                              key={colIndex}
                                              style={{
                                                padding: "15px",
                                                textAlign: col.align || "left",
                                                fontSize: "14px",
                                                fontWeight: "600",
                                                whiteSpace: "nowrap",
                                                color:
                                                  col.colors ||
                                                  (isdark === "light"
                                                    ? iscolour?.Colour12
                                                    : iscolourDark?.Colour12),
                                              }}
                                            >
                                              {col.key === "charts" ? (
                                                <div
                                                  onClick={() =>
                                                    setSelectedRow(row)
                                                  }
                                                  style={{
                                                    background: "#cde3d5",
                                                    width: "32px",
                                                    height: "32px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    borderRadius: "8px",
                                                    color: "#C9A13B",
                                                    margin: "auto",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  <BarChart3 size={16} />
                                                </div>
                                              ) : col.format ? (
                                                formatIndianNumber(value)
                                              ) : (
                                                value
                                              )}
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    ),
                                  )}

                                {/* ---------sub total------- */}
                                {isChildOpen &&
                                  hasMultipleChildRows &&
                                  (() => {
                                    const childRows =
                                      groupedData[parent][child];
                                    const totals = calculateTotals(childRows);

                                    return (
                                      <tr
                                        style={{
                                          background:
                                            isdark === "light"
                                              ? iscolour?.Colour7
                                              : iscolourDark?.Colour6,
                                          color:
                                            isdark === "light"
                                              ? iscolour?.Colour1
                                              : iscolourDark?.Colour12,
                                          fontWeight: "bold",
                                        }}
                                      >
                                        <td></td>

                                        {columns.map((col, i) => {
                                          let value = "";

                                          if (col.key === childKey) {
                                            value = "Total";
                                          } else if (isDashColumn(col.key)) {
                                            value = "-";
                                          } else if (col.key === "count") {
                                            value = childRows.length;
                                          } else {
                                            const externalValue =
                                              getExternalTotal(
                                                childTotals,
                                                childKeyUnique,
                                                col.key,
                                              );

                                            console.log("parent =>", parent);
                                            console.log(
                                              "parentTotals =>",
                                              parentTotals,
                                            );
                                            console.log(
                                              "externalValue =>",
                                              externalValue,
                                            );

                                            const finalValue =
                                              externalValue !== undefined
                                                ? externalValue
                                                : totals[col.key];

                                            if (finalValue !== undefined) {
                                              value =
                                                formatIndianNumber(finalValue);
                                            }
                                          }

                                          return (
                                            <td
                                              key={i}
                                              style={{
                                                padding: "12px",
                                                textAlign: "center",
                                                textAlign: col.align || "left",
                                              }}
                                            >
                                              {col.format
                                                ? value === "-" || value === ""
                                                  ? value
                                                  : formatIndianNumber(value)
                                                : value}
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    );
                                  })()}
                              </React.Fragment>
                            );
                          },
                        )}

                      {/* ----------parent total-------- */}
                      {isParentOpen &&
                        hasMultipleParentRows &&
                        (() => {
                          const parentRows = isSingleLevel
                            ? groupedData[parent]
                            : Object.values(groupedData[parent]).flat();
                          const totals = calculateTotals(parentRows);

                          return (
                            <tr
                              style={{
                                background:
                                  isdark === "light"
                                    ? iscolour?.Colour4
                                    : iscolourDark?.Colour8,
                                color:
                                  isdark === "light"
                                    ? "#000"
                                    : iscolourDark?.Colour1,
                                fontWeight: "bold",
                              }}
                            >
                              <td></td>

                              {columns.map((col, i) => {
                                let value = "";

                                if (col.key === parentKey) {
                                  value = "Total";
                                } else if (isDashColumn(col.key)) {
                                  value = "-";
                                } else if (col.key === "count") {
                                  value = parentRows.length;
                                } else {
                                  const externalValue = getExternalTotal(
                                    parentTotals,
                                    parent,
                                    col.key,
                                  );

                                  console.log("parent =>", parent);
                                  console.log("parentTotals =>", parentTotals);
                                  console.log(
                                    "externalValue =>",
                                    externalValue,
                                  );

                                  const finalValue =
                                    externalValue !== undefined
                                      ? externalValue
                                      : totals[col.key];

                                  if (finalValue !== undefined) {
                                    value = finalValue;
                                  }
                                }

                                return (
                                  <td
                                    key={i}
                                    style={{
                                      padding: "14px",
                                      textAlign: col.align || "left",
                                    }}
                                  >
                                    {col.format && value !== "-" && value !== ""
                                      ? formatIndianNumber(value)
                                      : value}
                                  </td>
                                );
                              })}
                            </tr>
                          );
                        })()}
                    </React.Fragment>
                  );
                })}

                {/* 🔥 GRAND TOTAL ROW */}
                <tr
                  style={{
                    background:
                      isdark === "light"
                        ? iscolour?.Colour6
                        : iscolourDark?.Colour11,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    fontWeight: "bold",
                  }}
                >
                  <td></td>

                  {columns.map((col, i) => {
                    let value = "";

                    if (col.key === parentKey) {
                      value = "Grand Total";
                    } else if (isDashColumn(col.key)) {
                      value = "-";
                    } else if (col.key === "count") {
                      value = sortedData.length;
                    } else {
                      const finalValue =
                        externalTotals && externalTotals[col.key] !== undefined
                          ? externalTotals[col.key]
                          : grandTotals[col.key];

                      if (finalValue !== undefined) {
                        value = finalValue;
                      }
                    }

                    return (
                      <td
                        key={i}
                        style={{
                          padding: "14px",
                          textAlign: col.align || "left",
                        }}
                      >
                        {col.format && value !== "-" && value !== ""
                          ? formatIndianNumber(value)
                          : value}
                      </td>
                    );
                  })}
                </tr>
              </tbody>
            </table>
          ) : (
            <div
              style={{
                position: "absolute",
                inset: 0,
                zIndex: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour5,
                overflow: "hidden",
                padding: "20px",
              }}
            >
              {/* BACKGROUND CIRCLE 1 */}
              <div
                style={{
                  position: "absolute",
                  width: "clamp(150px, 25vw, 250px)",
                  height: "clamp(150px, 25vw, 250px)",
                  borderRadius: "50%",
                  background:
                    isdark === "light"
                      ? "rgba(0,0,0,0.03)"
                      : "rgba(255,255,255,0.03)",
                  top: "-60px",
                  right: "-60px",
                }}
              />

              {/* BACKGROUND CIRCLE 2 */}
              <div
                style={{
                  position: "absolute",
                  width: "clamp(120px, 20vw, 180px)",
                  height: "clamp(120px, 20vw, 180px)",
                  borderRadius: "50%",
                  background:
                    isdark === "light"
                      ? "rgba(0,0,0,0.03)"
                      : "rgba(255,255,255,0.03)",
                  bottom: "-40px",
                  left: "-40px",
                }}
              />

              {/* PREMIUM EMPTY STATE CARD */}
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  maxWidth: "450px",
                  padding: "40px",
                  borderRadius: "24px",
                  background: isdark === "light" 
                    ? "rgba(255, 255, 255, 0.6)" 
                    : "rgba(30, 30, 35, 0.6)",
                  boxShadow: isdark === "light" 
                    ? "0 8px 32px rgba(0, 0, 0, 0.05)" 
                    : "0 8px 32px rgba(0, 0, 0, 0.3)",
                  backdropFilter: "blur(12px)",
                  border: isdark === "light" 
                    ? "1px solid rgba(255,255,255,0.8)" 
                    : "1px solid rgba(255,255,255,0.05)",
                  textAlign: "center",
                  margin: "20px auto",
                }}
              >
                {/* ICON CONTAINER WITH GLOW */}
                <div
                  style={{
                    width: "90px",
                    height: "90px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "24px",
                    background: isdark === "light" 
                      ? `${iscolour?.Colour11 || "#1e293b"}1A`
                      : `${iscolourDark?.Colour12 || "#f1f5f9"}26`,
                    boxShadow: isdark === "light" 
                      ? `0 10px 25px -5px ${iscolour?.Colour11 || "#1e293b"}33`
                      : `0 10px 25px -5px ${iscolourDark?.Colour12 || "#f1f5f9"}4D`,
                    color: isdark === "light" ? "#1e293b" : "#f1f5f9",
                  }}
                >
                  {search ? (
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="11" cy="11" r="8"/>
                      <path d="m21 21-4.3-4.3"/>
                      <path d="m9 9 4 4"/>
                      <path d="m13 9-4 4"/>
                    </svg>
                  ) : (
                    <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 12h-6l-2 3h-4l-2-3H2"/>
                      <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>
                    </svg>
                  )}
                </div>

                <h2
                  style={{
                    margin: "0 0 12px 0",
                    fontWeight: "700",
                    fontSize: "22px",
                    color: isdark === "light" ? "#1e293b" : "#f1f5f9",
                    letterSpacing: "-0.5px"
                  }}
                >
                  {search ? (
                    <span>
                      No results for <span style={{ color: isdark === "light" ? "#1e293b" : "#f1f5f9" }}>"{search}"</span>
                    </span>
                  ) : (
                    "No Data Available"
                  )}
                </h2>

                <p
                  style={{
                    margin: 0,
                    fontSize: "15px",
                    lineHeight: "1.6",
                    color: isdark === "light" ? "#64748b" : "#94a3b8",
                  }}
                >
                  {search
                    ? "We couldn't find anything matching your search. Please try a different term or clear the filter."
                    : "There are currently no records to display."
                  }
                </p>
              </div>
            </div>
          )}
        </div>

        {/* FOOTER */}

        {sortedData.length > 0 && (
          <div style={{ margin: "0px 10px" }}>
            <Row
              style={{
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour7,
                padding: "10px 0 25px 15px",
              }}
            >
              <Col
                sm={12}
                md={6}
                lg={6}
                className="text-center text-md-start p-0 pb-md-2"
              >
                <div>
                  Showing {indexOfFirstRow + 1} to{" "}
                  {Math.min(indexOfLastRow, sortedData.length)} of{" "}
                  {sortedData.length} results
                </div>
              </Col>
            </Row>
          </div>
        )}
      </div>
      {selectedRow && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
          onClick={() => setSelectedRow(null)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "90%",
              maxWidth: "1100px",
              background: "#fff",
              borderRadius: "12px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
            }}
            className="p-2 p-sm-3"
          >
            <Row>
              {/* CLOSE BUTTON ROW */}
              <Col xs={12} className="d-flex justify-content-end mb-3">
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => setSelectedRow(null)}
                >
                  Close
                </Button>
              </Col>

              {/* CHART ROW */}
              <Col xs={12} className="p-0">
                <Chart data={selectedRow} />
              </Col>
            </Row>
          </div>
        </div>
      )}
    </>
  );
};

export default PayRollParentChild;
